import {
    analyticsConsentChangedEventName,
    browserAnalyticsConsentState
} from "../AnalyticsConsent/AnalyticsConsentState";

type DataLayerValue = string | number | boolean;
type DataLayerEvent = Record<string, DataLayerValue>;
type AnalyticsWindow = Window & { dataLayer?: (DataLayerEvent | unknown[])[] };
type AnalyticsConsentReader = Pick<typeof browserAnalyticsConsentState, "isGranted">;

export function attachSeoAnalytics(
    documentRef: Document,
    windowRef: Window,
    consentState: AnalyticsConsentReader = browserAnalyticsConsentState
): () => void {
    let lastSignature = "";

    const emitPageView = () => {
        const body = documentRef.body;
        if (body?.dataset.seoAnalyticsEnabled !== "true") return;
        if (!consentState.isGranted()) return;

        const event = _pageView(body.dataset);
        if (!event) return;

        const signature = JSON.stringify(event);
        if (signature === lastSignature) return;

        lastSignature = signature;
        const analyticsWindow = windowRef as AnalyticsWindow;
        analyticsWindow.dataLayer ??= [];
        analyticsWindow.dataLayer.push(event);
    };

    const resetForVisit = () => {
        lastSignature = "";
    };

    documentRef.addEventListener("turbo:visit", resetForVisit);
    documentRef.addEventListener("turbo:load", emitPageView);
    windowRef.addEventListener(analyticsConsentChangedEventName, emitPageView);
    return () => {
        documentRef.removeEventListener("turbo:visit", resetForVisit);
        documentRef.removeEventListener("turbo:load", emitPageView);
        windowRef.removeEventListener(analyticsConsentChangedEventName, emitPageView);
    };
}

function _pageView(dataset: DOMStringMap): DataLayerEvent | null {
    const canonicalUrl = dataset.seoCanonicalUrl?.trim();
    const pageType = dataset.seoPageType?.trim();
    if (!canonicalUrl || !pageType) return null;

    const event: DataLayerEvent = {
        event: "smartguide_web_app_page_view",
        canonical_url: canonicalUrl,
        page_type: pageType,
        ui_language: dataset.seoUiLanguage?.trim() || "",
        content_language: dataset.seoContentLanguage?.trim() || ""
    };
    if (dataset.seoDestinationId?.trim()) event.destination_id = dataset.seoDestinationId.trim();
    if (dataset.seoEntityId?.trim()) event.entity_id = dataset.seoEntityId.trim();
    if (dataset.integrationKey?.trim()) event.integration_key = dataset.integrationKey.trim();
    if (dataset.integrationDeliveryKind?.trim()) {
        event.integration_delivery_kind = dataset.integrationDeliveryKind.trim();
    }

    return event;
}
